module.exports = __webpack_public_path__ + "img/uefa-champions-league-103.92c9ec01.png";